import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

export const SetupBanner = ({ api }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api("get", "/admin/setup-status").then(r => setS(r.data)).catch(() => {}); }, [api]);
  if (!s) return null;
  const issues = [...s.missing_wallets.map(w => <>Wallet for <b>{w.currency}</b> ({w.network}) is missing — set <code>{w.secret}</code></>), ...(s.reviewer_email ? [] : [<>Reviewer alerts are off — set <code>REVIEWER_EMAIL</code></>])];
  if (!issues.length) return null;
  return <div className="setup-banner" data-testid="admin-setup-banner"><AlertTriangle size={18}/><div><strong>SETUP INCOMPLETE — {s.missing_wallets.length ? "PAYMENTS ARE PAUSED" : "ACTION NEEDED"}</strong><ul>{issues.map((t, i) => <li key={i} data-testid={`setup-issue-${i}`}>{t}</li>)}</ul><small>Add these in Manage → Secrets, then restart or redeploy. Never paste a seed phrase or private key anywhere.</small></div></div>;
};
